import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Flag = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M3.5 21H5.5V15.5H19.759C20.5308 15.5 21.0116 14.6628 20.6227 13.9961L18 9.5L20.6227 5.00387C21.0116 4.33721 20.5308 3.5 19.759 3.5H3.5V21ZM5.5 5.5V13.5H18.0179L16.2724 10.5077C15.9092 9.88502 15.9092 9.11498 16.2724 8.49226L18.0179 5.5H5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Flag;
